import loadable from '@loadable/component';

export const ExpiredInternshipPageLoadable = loadable(
  () => import('./ExpiredInternshipPage'),
  { resolveComponent: (module) => module.ExpiredInternshipPage },
);
